import { PlanType } from 'api/billings/dtos'
import { TransactionType } from 'api/transactions/dtos'
import { IUser } from './models'

export enum InviteStatus {
	PENDING = 'PENDING',
	REJECTED = 'REJECTED',
	APPROVED = 'APPROVED',
}

export interface IUserDto {
	userId: string
	firstName: string
	lastName: string
	currentPlan: PlanType
	subscribedPlan?: PlanType
	email: string
	stripeChargeId: string
	referral?: 'coinomi' | 'no_referral'
	isCpa: boolean
	organizationId?: string // TODO: correct type once Organizations are added
	numberOfTransactionsAllowed: number
	numberOfRefreshesAllowed: number
	numberOfRefreshesUsed: number
	portfolioEnabled: boolean
	jurisdiction: string
	properties: Record<string, string>
	costBasisMethod: string
	paidUntil?: string
	hasCustomerId: boolean
	externalProvider?: {
		type: 'WEALTHICA' | null
		userId: string | null
	}
}

export interface IUserInviteDto {
	createdAt: number // fix that
	email: IUserDto['email']
	id: string
	retries: number
	sender: {
		id: IUserDto['userId']
		firstName: IUserDto['firstName']
		lastName: IUserDto['lastName']
		email: IUserDto['email']
	}
	status: InviteStatus
}

export interface IJurisdictionDto {
	allowedCostBasisMethods: {
		costBasisMethod: string
		isOfficiallyAllowed: boolean
	}[]
	defaultCurrency: string
	fullName: string
	localization: string
	shortName: string
}

export interface IFeatureAccessDto {
	reviewTransactionAccessible?: string
	downloadReportsAccessible?: string
	addTransaction?: string
	deleteAll?: string
	deleteAllIntegrations?: string
	deleteIntegration?: string
	deleteTransaction?: string
	generateReport?: string
	integrateBlockchainApiTransactions?: string
	integrateExchangeApiTransactions?: string
	integrateExchangeCsvTransactions?: string
	integrateTemplateCsvTransactions?: string
	integrateWalletCsvTransactions?: string
	modifyTransaction?: string
	performTaxAnalysis?: string
	performTransferMapping?: string
	recalculateValuations?: string
}

export interface ITutotialStatusDto {
	reports: boolean
	transactions: boolean
	imports: boolean
}

export interface IJurisdictionPropertiesDto {
	transactionProperties: Record<TransactionType, Record<string, string[]>>
	userProperties: Record<string, string[]>
	walletProperties: Record<string, string[]>
}

export interface IOnboardingDto {
	firstName: IUserDto['firstName']
	lastName: IUserDto['lastName']
	isCPA: IUserDto['isCpa']
	jurisdiction: IUserDto['jurisdiction']
	costBasisMethod: IUserDto['costBasisMethod']
}

export interface ISetWealthicaPlanParams {
	layer: IUser['currentPlan']
	nextPaymentDate?: string
}
